export const hasPermission = (userPermissions, requiredPermission) => {
    return (
        userPermissions.includes(requiredPermission) ||
        requiredPermission === "all"
    );
};

export const hasAnyPermission = (userPermissions, requiredPermissions) => {
    return requiredPermissions.some((permission) => {
        return userPermissions?.includes(permission) || permission === "all";
    });
};

export const hasAllPermissions = (userPermissions, requiredPermissions) => {
    return requiredPermissions.every(
        (permission) =>
            userPermissions.includes(permission) || permission === "all"
    );
};
